import rpc from "@/rpc";

class InformationPartService {
    rpc

    constructor(rpc) {
        this.rpc = rpc
    }

    resend(id) {
        return this.rpc.execute('resendCorrectionReport', {
            id
        })
    }

    reset(id) {
        return this.rpc.execute('resetCorrectionReport', {
            id
        })
    }

    get(id) {
        return this.rpc.execute('getCorrectionReport', {
            id
        })
    }
}

export default new InformationPartService(rpc)